import { selectTenantId } from "../../../../../util/store/selectors";
import { getStore } from "../../../../../util/store/store";
import { CERTAIN_TYPE, OP_STATUS, OPERATION_TYPE, SITE_TYPE } from "../../../../../util/varibles/constants";
import { uuid } from "../../../../../util/varibles/global";
import { ITransport, IUnit } from "../../../../../util/varibles/interface";
import { getEditOp } from "../EditOperationContext";

export const createTransport = (params: { unit: IUnit, operation_code?: string }, get: ReturnType<typeof getEditOp>): { operation: ITransport, amountStore: number } => {
    const userTenantId = selectTenantId(getStore());
    const { vessel, count } = get();
    const { capacity = 0 } = vessel || {};
    const { fish_amount, avg_weight, site_id = "", site_name = "", site_type } = params.unit;
    let amountOrder = fish_amount, amountStore, totalWeightOrder;
    if (site_type === SITE_TYPE.INTERNAL) {
        const amountDefault = Math.floor(capacity / avg_weight);
        if (amountOrder > amountDefault) {
            amountOrder = amountDefault;
            amountStore = fish_amount - amountDefault;
        } else
            amountStore = 0;

        totalWeightOrder = amountOrder * avg_weight;
    } else {
        amountOrder = 0;
        amountStore = 0;
        totalWeightOrder = 0;
    }

    return {
        operation: {
            id: uuid(),
            tenant_id: userTenantId,
            current_process: -1,
            operation_code: params.operation_code || `${count + 1}`,
            source_id: site_id,
            source_name: site_name,
            source_site_type: site_type,
            note: '',
            operation_type: OPERATION_TYPE.TRANSPORT,
            sub_destinations: [{
                ...params.unit,
                avg_weight,
                fish_amount: amountOrder,
                total_weight: totalWeightOrder,
            }],
            fish_amount: amountOrder,
            total_weight: totalWeightOrder,
            certain_mode: CERTAIN_TYPE.NONE,
            status: OP_STATUS.NEW
        } as ITransport,
        amountStore
    }
}


export function createTransports({ ...args }) {

}

interface IGetSubData {
    sub_destinations: IUnit[]
    source_site_type: SITE_TYPE
}

export function getSubData(item: IGetSubData) {
    let sub_destinations = item.sub_destinations.filter(item => item.delivery_id && item.fish_amount > 0);
    if (item.source_site_type === SITE_TYPE.EXTERNAL) {
        sub_destinations = sub_destinations.map((item: any) => {
            const { fish_amount, total_weight } = item;
            return { ...item, avg_weight: Math.round(total_weight / fish_amount) }
        })
    }
    const sub_operations = sub_destinations.reduce((list: any, item: any) => {
        const { id, fish_amount, total_weight } = item;
        if (list[id]) {
            list[id].fish_amount += fish_amount;
            list[id].total_weight += total_weight
        } else
            list[id] = item;
        return list;
    }, {})
    return {
        sub_destinations,
        sub_operations: Object.keys(sub_operations).reduce((list: any, key) => [...list, sub_operations[key]], [])
    }
}